module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('strong', [_c('em', [_vm._v("Abbreviations")])])])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ABD")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Anchor Bible Dictionary.")]), _vm._v(" Edited by David Noel Freedman. 6 vols. New York: Doubleday. 1992")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AJA")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("American Journal of Archaeology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AJAH")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("American Journal of Ancient History")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ANRW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Aufstieg und Niedergang der römischen Welt: Geschichte und Kultur Roms im Spiegel der neueren Forschung.")]), _vm._v(" Edited by Hildegard Temporini and Wolfgang Haase. Berlin and New York: Walter de Gruyter, 1972-")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Archaeological Reports")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ATR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Australasian Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BA")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Archaeologist")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BAGD")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Greek-English Lexicon of the New Testament and Other Early Christian Literature.")]), _vm._v(" Walter Bauer. Translated and edited by William F. Arndt and F. Wilbur Gingrich. Revised by F. Wilbur Gingrich and Frederick W. Danker. Chicago and London: University of Chicago Press, 1979")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BASOR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin of the American Schools of Oriental Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BBR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin for Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BCH")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin de correspondance hellénique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BDF")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Greek Grammar of the New Testament.")]), _vm._v(" F. Blass and A. Debrunner. Translated and edited by Robert W. Funk. Chicago and London: University of Chicago Press, 1961")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bib")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BGU")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Berliner Griechische Urkunden")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BJRL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin of the John Rylands Library")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BN")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblische Notizen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("BRev")])])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bible Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BSac")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bibliotheca Sacra")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Bible Translator")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Colloq")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Colloquium")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Comm")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Communio")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CP")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Classical Philology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Cuadernos de Teología")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DRev")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Downside Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EstBíb")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Estudios Bíblicos")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EstEcl")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Estudios Eclesiásticos")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ExpTim")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Expository Times")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("GR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Greece and Rome")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HSCP")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Harvard Studies in Classical Philology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Harvard Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Int")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IG")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Inscriptiones Graecae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Inscriptiones Graecae Epiri, Macedoniae, Thraciae, Scythiae, Pars II: Inscriptiones Macedoniae, Fasciculus I: Inscriptiones Thessalonicae et Viciniae.")]), _vm._v(" Edited by C. F. Edson. Berlin: W. de Gruyter, 1972")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Evangelical Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JHS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Hellenistic Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JPT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Pentecostal Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JRA")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Roman Archaeology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JRS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Roman Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JTSA")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Theology for Southern Africa")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("LAE")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Light from the Ancient East.")]), _vm._v(" Adolf Deissmann. Grand Rapids: Baker, 1978")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LSJ")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Greek-English Lexicon.")]), _vm._v(" Edited by Henry George Liddell and Robert Scott. Revised by Henry Stuart Jones and Roderick McKenzie. Oxford: Clarendon Press, 1968")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Lum")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Lumen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("MM")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Vocabulary of the Greek New Testament.")]), _vm._v(" James Hope Moulton and George Mulligan. Grand Rapids: Eerdmans, 1930")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NA")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Numina Aegaea")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_vm._v("NBD")])])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New Bible Dictionary.")]), _vm._v(" Edited by J. D. Douglas. Downers Grove, Ill.: InterVarsity Press, 1982.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NewDocs")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New Documents Illustrating Early Christianity.")]), _vm._v(" Edited by G. H. R. Horsley and S. R. Llewelyn. 8 vols. Grand Rapids: Eerdmans, 1981-98")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NIDNTT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New International Dictionary of New Testament Theology.")]), _vm._v(" Edited by Colin Brown. 4 vols. Grand Rapids: Zondervan, 1975-85")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NovT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Novum Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("OCD")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Oxford Classical Dictionary.")]), _vm._v(" Edited by Simon Hornblower and Antony Spawforth. Oxford and New York: Oxford University Press, 1996")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PCPS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Proceedings of the Cambridge Philological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Presb")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Presbyterion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Proy")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Proyección")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RB")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revue biblique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("REG")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revue des études grecques")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RevBíb")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revista Bíblica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RevPhil")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revue de philologie")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ResQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Restoration Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RIBLA")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revista de Interpretación Bíblica Latinoamericana")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Reformed Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Salm")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Salmanticensis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SIG"), _c('sup', [_vm._v("3")])])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sylloge Inscriptionum Graecarum.")]), _vm._v(" Edited by W. Dittenberger. 4 vols. Leipzig: S. Hirzelium, 1915-24")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Dictionary of the New Testament.")]), _vm._v(" Edited by Gerhard Kittel and Gerhard Friedrich. 10 vols. Grand Rapids: Eerdmans, 1964-76")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TLNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Lexicon of the New Testament.")]), _vm._v(" 3 vols. Ceslas Spicq. Peabody, Mass.: Hendrickson, 1994")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TTJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Trinity Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TynBul")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tyndale Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VD")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Verbum Domini")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("WesTJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Wesleyan Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZNW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZPE")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für Papyrologie und Epigraphik")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZTK")])])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für Theologie und Kirche")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-343d1f7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Abbreviations.vue
// module id = 78
// module chunks = 0